import { getIsApiPending } from '../../../selectors/eaTravelRates/auth';
import { apiTransitionVerify, verifySuccess } from '../../../actions/eaTravelRates/auth';
import axios from 'axios';
import { getAccessToken, getAuthForm } from '../../../selectors/eaTravelRates/auth';

export const verifyService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionVerify.pending());
            try {
                const resp = await calculate(store.getState());

                store.dispatch(verifySuccess(resp.data));
                store.dispatch(apiTransitionVerify.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionVerify.failure());
            }
        }
    })();
    return next(action);
};

const payload = (state) => {
    const auth = getAuthForm(state);

    const payload = {
        emailAddress: auth.email.value,
        otp: auth.otp.value,
    };

    return {
        ...payload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ea-travel-rates/verify';
        return await axios.post(url, payload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
